export default __webpack_public_path__ + "static/media/EIXrECqXUAAQBxa.fa8b4ae3.jpg";